import { sortBy, toNumber, upperCase } from 'lodash-es';
import {
  CloudActions,
  CloudReducerState,
  FETCH_CPU_PLATFORM,
  FETCH_CPU_PLATFORM_IS_ERROR,
  FETCH_CPU_PLATFORM_IS_PENDING,
  FETCH_DC_LOCATION,
  FETCH_DC_LOCATION_BY_ID,
  FETCH_DC_LOCATION_BY_ID_IS_ERROR,
  FETCH_DC_LOCATION_BY_ID_IS_PENDING,
  FETCH_DC_LOCATION_IS_ERROR,
  FETCH_DC_LOCATION_IS_PENDING,
  FETCH_INSTANCE_TYPES,
  FETCH_INSTANCE_TYPES_IS_ERROR,
  FETCH_INSTANCE_TYPES_IS_PENDING,
  FETCH_PROVIDERS_DETAILS,
  FETCH_PROVIDERS_DETAILS_IS_ERROR,
  FETCH_PROVIDERS_DETAILS_IS_PENDING,
} from 'services/GameHosting/Cloud/types';
import { CLEAN_ERROR } from 'utils/apiActionTypes';
import notEmpty from 'utils/common/notEmpty';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  dcLocations: [],
  providers: [],
  instances: [],
  cpuPlatforms: [],
  dcLocationById: undefined,
  fetchDcLocationsIsCompleted: false,
  fetchDcLocationsIsPending: false,
  fetchDcLocationsIsError: null,
  fetchProvidersDetailsIsCompleted: false,
  fetchProvidersDetailsIsPending: false,
  fetchProvidersDetailsIsError: null,
  fetchInstanceTypesIsCompleted: false,
  fetchInstanceTypesIsPending: false,
  fetchInstanceTypesIsError: null,
  fetchCpuPlatformIsCompleted: false,
  fetchCpuPlatformIsPending: false,
  fetchCpuPlatformIsError: null,
  fetchDcLocationsByIdIsCompleted: false,
  fetchDcLocationsByIdIsPending: false,
  fetchDcLocationsByIdIsError: null,
} satisfies CloudReducerState;

const cloudReducer = (previousState: CloudReducerState | undefined, action: CloudActions): CloudReducerState => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_DC_LOCATION: {
      const { data } = action;
      const dcLocations = sortBy(data ?? [], [(location) => toNumber(location.providerId), (location) => upperCase(location.displayName)]);

      return {
        ...state,
        dcLocations,
        fetchDcLocationsIsCompleted: true,
        fetchDcLocationsIsPending: false,
        fetchDcLocationsIsError: null,
      };
    }

    case FETCH_DC_LOCATION_IS_PENDING:
      return {
        ...state,
        fetchDcLocationsIsCompleted: false,
        fetchDcLocationsIsPending: true,
        fetchDcLocationsIsError: null,
      };
    case FETCH_DC_LOCATION_IS_ERROR:
      return {
        ...state,
        fetchDcLocationsIsCompleted: true,
        fetchDcLocationsIsPending: false,
        fetchDcLocationsIsError: action.error,
      };

    case FETCH_DC_LOCATION_BY_ID:
      return {
        ...state,
        dcLocationById: action.data,
        fetchDcLocationsByIdIsCompleted: true,
        fetchDcLocationsByIdIsPending: false,
        fetchDcLocationsByIdIsError: null,
      };
    case FETCH_DC_LOCATION_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchDcLocationsByIdIsCompleted: false,
        fetchDcLocationsByIdIsPending: true,
        fetchDcLocationsByIdIsError: null,
      };
    case FETCH_DC_LOCATION_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchDcLocationsByIdIsCompleted: true,
        fetchDcLocationsByIdIsPending: false,
        fetchDcLocationsByIdIsError: action.error,
      };

    case FETCH_PROVIDERS_DETAILS: {
      const { data } = action;

      const providers = notEmpty(data)
        ? sort(
            data.filter(({ active }) => active),
            {
              sortBy: 'name',
              sortDirection: 'ASC',
            },
          )
        : [];

      return {
        ...state,
        providers,
        fetchProvidersDetailsIsCompleted: true,
        fetchProvidersDetailsIsPending: false,
        fetchProvidersDetailsIsError: null,
      };
    }

    case FETCH_PROVIDERS_DETAILS_IS_PENDING:
      return {
        ...state,
        fetchProvidersDetailsIsCompleted: false,
        fetchProvidersDetailsIsPending: true,
        fetchProvidersDetailsIsError: null,
      };
    case FETCH_PROVIDERS_DETAILS_IS_ERROR:
      return {
        ...state,
        fetchProvidersDetailsIsCompleted: true,
        fetchProvidersDetailsIsPending: false,
        fetchProvidersDetailsIsError: action.error,
      };
    case FETCH_INSTANCE_TYPES:
      return {
        ...state,
        instances: action.data ?? [],
        fetchInstanceTypesIsCompleted: true,
        fetchInstanceTypesIsPending: false,
        fetchInstanceTypesIsError: null,
      };
    case FETCH_INSTANCE_TYPES_IS_PENDING:
      return {
        ...state,
        fetchInstanceTypesIsCompleted: false,
        fetchInstanceTypesIsPending: true,
        fetchInstanceTypesIsError: null,
      };
    case FETCH_INSTANCE_TYPES_IS_ERROR:
      return {
        ...state,
        fetchInstanceTypesIsCompleted: true,
        fetchInstanceTypesIsPending: false,
        fetchInstanceTypesIsError: action.error,
      };
    case FETCH_CPU_PLATFORM:
      return {
        ...state,
        cpuPlatforms: action.data ?? [],
        fetchCpuPlatformIsCompleted: true,
        fetchCpuPlatformIsPending: false,
        fetchCpuPlatformIsError: null,
      };
    case FETCH_CPU_PLATFORM_IS_PENDING:
      return {
        ...state,
        fetchCpuPlatformIsCompleted: false,
        fetchCpuPlatformIsPending: true,
        fetchCpuPlatformIsError: null,
      };
    case FETCH_CPU_PLATFORM_IS_ERROR:
      return {
        ...state,
        fetchCpuPlatformIsCompleted: true,
        fetchCpuPlatformIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchCpuPlatformIsError: action.error.message,
      };
    case CLEAN_ERROR:
      return {
        ...state,
        fetchDcLocationsIsError: null,
        fetchProvidersDetailsIsError: null,
        fetchInstanceTypesIsError: null,
        fetchCpuPlatformIsError: null,
      };
    default:
      return state;
  }
};

export default cloudReducer;
